import React from 'react';
import cx from 'classnames';
import { useExperiments } from '@wix/yoshi-flow-editor';
import s from './ProductPageApp.scss';
import { StateProvider } from '../stores';
import { SPECS } from '../../../../consts';

import ProductPageBody from '../Components/ProductPageBody/ProductPageBody';

export enum ProductPageAppDataHook {
  root = 'ProductPageAppDataHook.root',
}
function ProductPageApp() {
  const { experiments } = useExperiments();
  const isCssVars = experiments.enabled(SPECS.MigrateGiftCardWidgetToCssVars);
  const classNames = cx(s.main, s.viewer_classic);

  return (
    <div
      className={cx(s.container, isCssVars && s.queryContainer)}
      data-hook={ProductPageAppDataHook.root}
    >
      <main className={classNames}>
        <StateProvider>
          <ProductPageBody />
        </StateProvider>
      </main>
    </div>
  );
}

export default ProductPageApp;
